

// When `reset` is true return `undefined` to set a pristine field
export function emptyError(value, reset = true) {
  if (value && value.length) {
    return false;
  }
  return reset ? undefined : true;
}

export function noMatchError(value, valueToMatch, reset) {
  const noValue = emptyError(value, reset);
  const noMatchValue = emptyError(valueToMatch, reset);
  return noValue === false && noMatchValue === false
    ? value !== valueToMatch
    : noValue;
}

export function minimumCharsError(value, minimumChars, reset) {
  const noValue = emptyError(value, reset);
  return noValue === false ? value.length < minimumChars : noValue;
}

export function upperCaseError(value, reset) {
  const noValue = emptyError(value, reset);
  return noValue === false ? !/[A-Z]/.test(value) : noValue;
}

export function lowerCaseError(value, reset) {
  const noValue = emptyError(value, reset);
  return noValue === false ? !/[a-z]/.test(value) : noValue;
}

export function equalPassword(oldPassword, newPassword) {
  return oldPassword === newPassword;
}

export function specialCharsError(value, reset) {
  const noValue = emptyError(value, reset);
  return noValue === false ? !/[\W]/.test(value) : noValue;
}

export function specialCharsErrorForCH(value, reset) {
  const noValue = emptyError(value, reset);
  var val = value.replace(/[0-9a-zA-Z ]/g, "");
  return noValue === false ? !/^[$@#()|^*]+$/.test(val) : noValue;
}

export function numericalError(value, reset) {
  const noValue = emptyError(value, reset);
  return noValue === false ? !/[0-9]/.test(value) : noValue;
}
export function SpecialCharsAtStart(value, reset){
  const noValue = emptyError(value, reset);
  return noValue === false ? !/^[A-Za-z0-9]/.test(value) : noValue
}